import styled, { keyframes } from "styled-components";
import { fadeInDown } from "react-animations";
import NumberFormat from "react-number-format";
import { primaryColor, primaryColorHover, errorColor, bodyColor } from "../../../../../config/constants";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInDown}`;

export const EvaluationDataDiv = styled.div`
  width: 100%;
  max-width: 860px;
  padding: 15px;
  border-radius: 5px;
  border-left: 8px solid ${primaryColor};
  background-color: #fff;
  animation: 0.4s ${fadeInDownAnimation};
`;
export const TitleDiv = styled.div`
  display: flex;
  justify-content: flex-start;
`;
export const Title = styled.p`
  color: #000;
`;
export const DataDiv = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: center;
  }
`;
export const ColumnDataDiv = styled.div`
  width: ${({ width }) => width && width};
  display: flex;
  flex-direction: column;
  @media (max-width: 910px) {
    width: 220px;
  }
`;
export const InputDataDiv = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
  justify-content: flex-end;
  position: relative;
  @media (max-width: 910px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const Label = styled.label`
  margin-right: 15px;
  font-size: 14px;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "normal")};
  text-align: right;
`;
export const EvaluationDateInput = styled(NumberFormat)`
  padding: 5px 10px;
  width: 190px;
  border: ${({ border }) => border && border};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const Textarea = styled.textarea`
  padding: 5px 10px;
  width: 190px;
  min-width: 190px;
  max-width: 190px;
  min-height: 80px;
  max-height: 105px;
  border: 1px solid ${bodyColor};
  outline: none;
  border-radius: 5px;
  font-size: 12px;
`;
export const ManagementDiv = styled.div`
  margin: 20px 0 10px;
  padding: 0 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent && justifyContent};
  @media (max-width: 910px) {
    width: 85%;
  }
  @media (max-width: 570px) {
    justify-content: flex-start;
  }
  @media (max-width: 400px) {
    margin: 0;
  }
`;
export const SaveAndCancelDiv = styled.div`
  display: flex;
`;
export const SaveButton = styled.button`
  margin-right: 10px;
  padding: 10px 16px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background-color: ${primaryColor};
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
export const CancelButton = styled.button`
  padding: 10px 16px;
  border: 1px solid ${primaryColor};
  border-radius: 5px;
  color: ${primaryColor};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: transparent;
  outline: none;
  cursor: pointer;
`;
export const DeleteButton = styled.button`
  padding: 10px 16px;
  border: 1px solid ${errorColor};
  border-radius: 5px;
  color: ${errorColor};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: transparent;
  outline: none;
  cursor: pointer;
`;
